import React, { useEffect, useState } from 'react';
import { StyledMBTACallout } from './MBTACallout.styles';
import { fetchMBTAcalloutData } from '../../api/mbtaCalloutService';
import { CarouselContainer } from '../../molecules/CarouselContainer';
import { Heading, Text, Types } from '@marriott/mi-ui-library';
import { MBTACalloutProps, MBTAExperience } from './MBTACallout.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MBTACallout: React.FC<MBTACalloutProps> = ({
  marshaCode,
  startDate,
  endDate,
  resCurrency,
  formDataHotelLocation,
  brandCodeProps,
  colorScheme,
  prefetchedMbtaData,
}) => {
  const [mbta, setMbta] = useState<MBTAExperience[]>(prefetchedMbtaData || []);
  const [isLoading, setIsLoading] = useState(!(Array.isArray(prefetchedMbtaData) && prefetchedMbtaData.length > 0));
  const [hotelLocation, setHotelLocation] = useState('');
  const [loadMoreUrl, setLoadMoreUrl] = useState('');

  useEffect(() => {
    if (Array.isArray(prefetchedMbtaData) && prefetchedMbtaData.length > 0) {
      setMbta(prefetchedMbtaData);
      setIsLoading(false);
    }
  }, [prefetchedMbtaData]);

  useEffect(() => {
    const arrivalDate = startDate?.replaceAll('-', '');
    const departureDate = endDate?.replaceAll('-', '');
    const scope = 'full';
    const currency = resCurrency || 'USD';
    const hasPrefetchedData = Array.isArray(prefetchedMbtaData) && prefetchedMbtaData.length > 0;

    if (!marshaCode) {
      return;
    }

    setHotelLocation(formDataHotelLocation || 'your stay');
    setLoadMoreUrl(
      'https://activities.marriott.com/property/' +
        marshaCode +
        '?utm_source=marriott_com&utm_medium=travel_form&utm_campaign=prearrival&prearrival=expB&from=' +
        arrivalDate +
        '&to=' +
        departureDate
    );

    if (hasPrefetchedData) {
      setIsLoading(false);
      return;
    }

    const fetchMBTAData = async () => {
      setIsLoading(true);
      const mbtaData = await fetchMBTAcalloutData({
        scope,
        code: marshaCode,
        currency,
        from: arrivalDate,
        to: departureDate,
      });
      setMbta(Array.isArray(mbtaData?.response) ? mbtaData.response : []);
      setIsLoading(false);
    };
    fetchMBTAData();
  }, [marshaCode, startDate, endDate, resCurrency, formDataHotelLocation, prefetchedMbtaData]);

  if (!isLoading && !mbta?.length) {
    return null;
  }

  return (
    <StyledMBTACallout>
      <div id="personalized-mbta-callout" className={`container mbta-container mbta-section ${colorScheme}`}>
        <Heading
          variation={Types.headingType.title}
          fontSize={Types.size.small}
          element={Types.tags.h3}
          titleText="Let the Exploring Begin"
          customClass="small-h6 mb-0 heading-top-margin"
        ></Heading>
        <Text
          element={Types.tags.paragraph}
          fontSize={Types.size.large}
          dangerouslySetInnerHTML={{
            __html: 'Discover the sights, flavors, and experiences that make ' + hotelLocation + ' unforgettable.',
          }}
          customClass="subtext mb-2"
        ></Text>
        {mbta?.length ? (
          <CarouselContainer
            amenitiesDetails={mbta}
            componentType="MBTA"
            arrivalDate={startDate}
            departureDate={endDate}
            eventId="Upcoming"
            componentEventId="MBTA_Callout"
            brandCode={brandCodeProps}
          ></CarouselContainer>
        ) : (
          <Text
            element={Types.tags.paragraph}
            fontSize={Types.size.medium}
            copyText="Loading local experiences..."
            customClass="mb-2"
          ></Text>
        )}

        <a href={loadMoreUrl} target="_blank" rel="noreferrer">
          <button className="m-button-secondary addButton custom-btn mx-0 ">Explore More Local Experiences</button>
        </a>
      </div>
    </StyledMBTACallout>
  );
};
